const prefix = "bubble:user-document:v1:";
const lifetime = 5 * 60 * 1000;

/** A same-tab copy of the signed-in owner's document, never an auth token. */
export function readSessionUser(
  uid: string | undefined,
  path: string,
): unknown {
  if (!uid || path !== `users/${uid}`) {
    return;
  }
  try {
    const raw = sessionStorage.getItem(prefix + uid);
    if (!raw) {
      return;
    }
    const entry = JSON.parse(raw);
    if (
      entry.uid !== uid ||
      entry.value?.uid !== uid ||
      typeof entry.readAt !== "number" ||
      Date.now() - entry.readAt > lifetime ||
      entry.readAt > Date.now()
    ) {
      sessionStorage.removeItem(prefix + uid);
      return;
    }
    return entry.value;
  } catch {
    return;
  }
}

export function writeSessionUser(
  uid: string | undefined,
  path: string,
  value: unknown,
) {
  if (!uid || path !== `users/${uid}`) {
    return;
  }
  try {
    if (
      !value ||
      typeof value !== "object" ||
      !("uid" in value) ||
      value.uid !== uid
    ) {
      sessionStorage.removeItem(prefix + uid);
      return;
    }
    sessionStorage.setItem(
      prefix + uid,
      JSON.stringify({ uid, value, readAt: Date.now() }),
    );
  } catch {
    /* Disabled or full storage must not prevent normal Firebase reads. */
  }
}

/** Preserve only the restored owner on first hydration; clear everything at sign-out/switch. */
export function clearSessionUsers(preserveUid?: string) {
  try {
    for (const key of Object.keys(sessionStorage)) {
      if (
        key.startsWith(prefix) &&
        (!preserveUid || key !== prefix + preserveUid)
      ) {
        sessionStorage.removeItem(key);
      }
    }
  } catch {
    /* Storage can be disabled. */
  }
}
